import { render, staticRenderFns } from "./riskControlRecordListModel.vue?vue&type=template&id=4e6102d3&"
import script from "./riskControlRecordListModel.vue?vue&type=script&lang=js&"
export * from "./riskControlRecordListModel.vue?vue&type=script&lang=js&"
import style0 from "./riskControlRecordListModel.vue?vue&type=style&index=0&id=4e6102d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports